import { Divider, Flex, Heading } from 'pcln-design-system'
import React from 'react'
import { Reset } from '../../AllOrNone'

export const FilterHeader = ({ headerText = '', resetHandler }) => (
  <>
    <Flex mb={2} alignItems='center' justifyContent='space-between'>
      <Heading fontSize={2} bold>
        {headerText}
      </Heading>
      <Reset resetHandler={resetHandler}>Reset</Reset>
    </Flex>
    <Divider mb={3} mt={0} />
  </>
)
